// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eaeee4b8","732":"992b31af","977":"5f1f123b"}[chunkId] + ".chunk.js";
};